import { Outlet, createFileRoute, useLocation } from "@tanstack/react-router";

import { ForgeAutomationsPage } from "../components/automations/ForgeAutomationsPage";

export const Route = createFileRoute("/_chat/automations")({
  component: AutomationsRouteLayout,
});

function AutomationsRouteLayout() {
  const pathname = useLocation({ select: (location) => location.pathname });
  return pathname === "/automations" ? <ForgeAutomationsPage /> : <Outlet />;
}
